<template>
    <div class="shopping-cart">
        <navbar></navbar>
        <div class="box-header">
            <h1 class="box-title">{{$t('user_center_order_shopping_cart')}}</h1>
            <router-link :to="{name:'Order'}" class="box-button">{{$t('user_order_my_order')}}</router-link>
        </div>
        <div class="profile-cart-table">
            <div v-if="goods.length === 0" class="profile-cart-empty">
                <img src="../../assets/profile/empty-cart.png" alt="">
                <router-link :to="{name:'FooterShop'}">
                    <p>
                        <Button  style="font-size: 16px;" type="text">{{$t('shopping_card_go_to_shopping')}}</Button>
                    </p>
                </router-link>
            </div>
            <div v-else>
                <div class="cart-group pc-show">
                    <div v-if="screenWidth">
                        <div class="cart-header">
                            <div style="text-align: left;"><Checkbox style="margin-left: 8px;font-size: 14px;"
                                 @on-change="selectAll" v-model="selectAll">{{$t('shopping_card_selected')}}</Checkbox></div>
                            <div class="cart-item"><span>{{$t('user_center_order_product')}}</span></div>
                            <div class="cart-item"><span>{{$t('user_center_order_price')}}</span></div>
                            <div class="cart-item"><span>{{$t('user_center_order_Quantity')}}</span></div>
                            <div class="cart-item"><span>{{$t('user_center_order_Subtotal')}}</span></div>
                            <div class="cart-item"><span>{{$t('user_order_operation')}}</span></div>
                        </div>
                        <div class="cart-list" v-for="(item,index,key) in goods">
                            <div class="cart-row cart-header">
                                <div>
                                    <!--:label="goods.id" v-model="goods.isSelect"-->
                                    <Checkbox class="goods-checkbox" v-model="item.if_checked">
                                        <div class="goods-header">
                                            <img :src="item.goods_img" alt="">
                                        </div>
                                    </Checkbox>
                                </div>
                                <div class="goods-desc">
                                    <h3>{{item.goods_name}}</h3>
                                    <p>{{item.goodsDesc}}</p>
                                </div>
                                <div class="goods-price">${{item.goods_price}}</div>
                                <div class="goods-num">
                                    <div class="goods-num-editable">
                                        <button type="button" class="minus" @click="min(index)">
                                            <Icon type="minus" size="12"></Icon>
                                        </button>
                                        <span class="number">{{item.goods_num}}</span>
                                        <button type="button" class="plus" @click="max(index)">
                                            <Icon type="plus" size="12"></Icon>
                                        </button>
                                    </div>
                                </div>
                                <div class="goods-price text-primary">${{item.goods_price * item.goods_num}}</div>
                                <div class="goods-operation">
                                    <a href="javascript:;" @click="remove_order(index)">
                                        <Icon type="close"/>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="moblie-cart-list" v-for="(item,index,key) in goods" v-else>
                        <div class="goods-header">
                            <img :src="item.goods_img" alt="">
                        </div>
                        <div class="goods-desc">
                            <h3>
                                {{item.goods_name}}
                                <a href="javascript:;" @click="remove_order(index)">
                                    <Icon type="close"/>
                                </a>
                            </h3>
                            <p>${{item.goods_price}}</p>
                            <div class="goods-num">
                                <div class="goods-num-editable">
                                    <button type="button" class="minus" @click="min(index)">
                                        <Icon type="minus" size="12"></Icon>
                                    </button>
                                    <span class="number">{{item.goods_num}}</span>
                                    <button type="button" class="plus" @click="max(index)">
                                        <Icon type="plus" size="12"></Icon>
                                    </button>
                                    <div class="goods-price text-primary">${{item.goods_price * item.goods_num}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="cart-box" v-if="screenWidth">
                        <div class="prifile-cart-total">
                            <div class="cart-total-left">
                                <router-link class="font_small" :to="{name:'FooterShop'}">
                                    <Button type="text" size="large" style="font-size: 16px;">{{$t('continue_purchase')}}</Button>
                                </router-link>
                                <div class="cart-calculate">
                                    {{$t('total_part_2',{totalCount:selectedNum,selectedCount:orderNumberTotal})}}
                                </div>
                            </div>
                            <div class="cart-total-right">
                                <div class="cart-subtotal">
                                    <span>{{$t('user_center_order_total_tip')}}:</span>
                                    <span class="text-primary total-price">USD ${{orderTotal}}</span>
                                </div>
                                <Button type="primary" class="check_btn" @click="checkOut">{{$t('check_out_btn')}}</Button>
                            </div>
                        </div>
                    </div>
                    <div class="cart-boxmobile" v-else>
                        <ul>
                            <li>{{$t('user_center_order_Subtotal')}}:</li>
                            <li class="text-primary total-price">USD ${{orderTotal}}</li>
                            <li>A total of {{orderNumberTotal}} pieces</li>
                            <li><Button type="primary" class="check_btn" @click="checkOut">{{$t('check_out_btn')}}</Button></li>
                            <li>
                                <Button type="primary" class="check_btn1" @click="checkOut_tour">{{$t('tourist_guest')}}</Button>
                            </li>
                        </ul>

                        <div style="clear:both;"></div>
                    </div>
                </div>
                <div class="tip_text" v-if="screenWidth">
                    <p>
                        <!--Tips: if the product is successful, the final cart shall prevail. Please settle the account as soon as possible-->
                    </p>
                </div>

                <div class="payment-box">
                    <modal v-model="modal1" size="small">
                        <div slot="header"></div>
                        <div class="tip-alert">
                            <p class="tip-title">{{$t('user_center_Coupons_Use_tips')}}</p>
                            <p class="tip-body">Download the app to buy more packages</p>
                            <div class="tip-button">
                                <Button type="ghost" class="tip-cancel" @click="modal1 = !modal1">
                                    {{$t('cancel_btn')}}
                                </Button>
                                <Button type="primary" class="tip-download">
                                    {{$t('download_btn')}}
                                </Button>
                            </div>
                        </div>
                        <div slot="footer"></div>
                    </modal>

                    <div>
                        <guess></guess>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import orderGroup from '../Profiler/Common/OrderGroup.vue'
    import orderList from '../Profiler/Common/OrderList.vue'
    import guess from '../Profiler/Common/Guess.vue'
    import navbar from '../Common/Navbar.vue'
    import modal from '../Common/Modal.vue'
    import Signature from '../../lib/Signature'

    export default {
        data () {
            return {
                modal1: false,
                selectAll:true,
                isEdit: true,
                selectList: [],
                guessList: [
                    {
                        name: '产品名1这个可能要很长来甜酸我就是乱打哈哈哈哈',
                        img: '',
                        price: '110',
                        originalPrice: '$123',
                        id: 1
                    },
                    {
                        name: '这怎么能行呢',
                        img: '',
                        price: '110',
                        originalPrice: '$123',
                        id: 2
                    },
                    {
                        name: '产品名3',
                        img: '',
                        price: '110',
                        originalPrice: '$123',
                        id: 3
                    }
                ],
                goods: []
            }
        },
        components: {
            'cart-group': orderGroup,
            'cart-list': orderList,
            guess,
            navbar,
            modal
        },
        computed: {
            selectedNum () {
                return this.goods.length
            },
            screenWidth: function () {
                return document.body.clientWidth > 768
            },
            orderTotal () {
                let total = 0
                for (let item of this.goods) {
                    if (item.if_checked === true) {
                        total += parseFloat(item.goods_price) * parseInt(item.goods_num)
                    }
                }
                return total
            },
            orderNumberTotal () {
                let total = 0
                for (let item of this.goods) {
                    if (item.if_checked === true) {
                        total += parseInt(item.goods_num)
                    }
                }
                return total
            }
        },
        created () {
            this.getOrder()
        },
        methods: {
            getOrder(){
                let module = 'index.php/index/shopcar/carinfo'
                let data = {}
                data.sub_time = Signature.timestamp()
                data.sign = Signature.create(module, data.sub_time)
                if (!this.Local.isLogin()) {
                    data.tourists_token = this.Local.get('tourists_token')
                }else{
                    data.user_id = this.Local.getUserId()
                }
                data.token = this.Local.getUserToken()
                this.$http.get(process.env.BASEURL + module, {params: data})
                    .then(function (response) {
                        this.goods = response.data.data
                    }.bind(this))
            },
            checkOut_tour () {
                let data = {}
                data.goods_id = []
                data.number = []
                for (let item of this.goods) {
                    if (item.if_checked === true) {
                        data.goods_id.push(item.goods_id)
                        data.number.push(item.goods_num)
                    }
                }
                data.goods_id = data.goods_id.join(',')
                data.number = data.number.join(',')
                this.$router.push({
                    name: 'Confirmation'
                })
                this.Local.set("CartGoods_id",data.goods_id)
                this.Local.set("CartGoods_number",data.number)
            },
            checkOut () {
                if (this.orderTotal === 0) {
                    this.$Message.error(this.$t('user_message_please_choose_product'))
                    return false
                }
                //判断用户登录
                if (!this.Local.isLogin()) {
                    this.$busEvent.$emit('login')
                }else{
                    let data = {}
                    data.goods_id = []
                    data.number = []
                    for (let item of this.goods) {
                        if (item.if_checked === true) {
                            data.goods_id.push(item.goods_id)
                            data.number.push(item.goods_num)
                        }
                    }
                    data.goods_id = data.goods_id.join(',')
                    data.number = data.number.join(',')
                    this.$router.push({
                        name: 'Settlement',
                        query: {
                            goods_id: data.goods_id,
                            number: data.number
                        }
                    })
                }
            },
            remove_order (index) {
                let module = 'index.php/index/shopcar/delcart'
                let data = {}
                data.sub_time = Signature.timestamp()
                data.sign = Signature.create(module, data.sub_time)
                if (!this.Local.isLogin()) {
                    data.tourists_token = this.Local.get('tourists_token')
                }else{
                    data.user_id = this.Local.getUserId()
                }
                data.token = this.Local.getUserToken()
                data.lang = this.$i18n.locale
                data.goods_id = this.goods[index]['goods_id']
                data.number = this.goods[index]['goods_num']
                this.$http.post(process.env.BASEURL + module, data)
                .then(function (response) {
                    if (parseInt(response.data.code) === 2000) {
                        this.goods.splice(index, 1)
                        this.$busEvent.$emit('delcart', 1)
                    }
                }.bind(this))
            },
            updateCart (index, type = 'addcart', range = [1, 99]) {
                let module = 'index.php/index/shopcar/' + type
                let data = {}
                data.sub_time = Signature.timestamp()
                data.sign = Signature.create(module, data.sub_time)
                if (!this.Local.isLogin()) {
                    data.tourists_token = this.Local.get('tourists_token')
                }else{
                    data.user_id = this.Local.getUserId()
                }
                data.token = this.Local.getUserToken()
                data.lang = this.$i18n.locale
                data.goods_id = this.goods[index]['goods_id']
                data.number = 1

                if (type === 'delcart' && this.goods[index]['goods_num'] === range[0]) {
                    return false
                }
                if (type === 'addcart' && this.goods[index]['goods_num'] === range[1]) {
                    return false
                }
                this.$http.post(process.env.BASEURL + module, data)
                .then(function (response) {
                    if (parseInt(response.data.code) === 2000) {
                        if (type === 'addcart') {
                            this.goods[index]['goods_num'] += 1
                            this.getOrder()
                            if (this.goods[index]['goods_num'] > range[1]) {
                                this.goods[index]['goods_num'] = range[1]
                            }
                        } else {
                            this.goods[index]['goods_num'] -= 1
                            if (this.goods[index]['goods_num'] < range[0]) {
                                this.goods[index]['goods_num'] = range[0]
                            }
                        }
                    } else {
                        alert('网络错误')
                    }
                }.bind(this))
            },
            selectAll (type) {
                for (let i in this.goods) {
                    if (type) {
                        this.goods[i]['if_checked'] = true
                    } else {
                        this.goods[i]['if_checked'] = false
                    }
                }
            },
            min (index) {
                this.updateCart(index, 'delcart', [
                    1,
                    this.goods[index]['store_count']
                ])
            },
            max (index) {
                this.updateCart(index, 'addcart',
                    [
                        1,
                        this.goods[index]['store_count']
                    ])
            },
            cancel (index) {
                for (let i in this.goods) {
                    if (index === this.goods[i].id) {
                        this.goods.splice(i, 1)
                    }
                }
            }
        }
    }
</script>
<style lang="scss" type="text/scss" scoped>
    @import "../../scss/common";
    @import "../../scss/components/toast";
    @import "../../scss/navbar";
    @import "../../scss/shoppingcart";
    .shopping-cart{
        .box-header{
            width:90%;
            max-width:1240px;
        }
         .cart-box{
            max-width: 1280px;
            padding: 10px 15px;
            margin: 0 auto;
            background: #ffffff;
            border: 1px solid #C0CCDA;
        }
        .profile-cart-table{
            .cart-group{
                .cart-header{
                    max-width: 1240px;
                    width: 100%;
                    .goods-num{
                        .goods-num-editable{
                            margin: 0 auto;
                        }
                    }
                    .goods-header{
                        min-width: 150px;
                    }
                    div{
                        width:18%;
                        text-align: center;
                    }
                }
                .cart-list{
                    max-width: 1280px;
                    margin: 0 auto;
                    .cart-header{
                        padding-left: 20px;
                    }
                }
            }
            .check_btn{
                /*font-family: PingFangSC-Medium;*/
                font-size: 20px;
                height: 40px;
                width: 150px;
                padding: 0;
            }
            .mobile-show{
                display: none;
            }
        }
        @media screen and (max-width: 770px){
            .moblie-cart-list{
                display: flex;
                margin: 15px;
                border-bottom: 1px solid #e6e6e6;
                .goods-header{
                    width: 35%;
                    img{
                        width: 100%;
                        max-width: 200px;
                        min-width: 100px;
                    }
                }
                .goods-desc{
                    width: 65%;
                    padding-left: 20px;
                    text-align: left;
                    h3{
                        font-size: 16px;
                        a{
                            float: right;
                            padding-right: 10px;
                        }
                    }
                    p{
                        margin-right: 10px;
                        margin-bottom: 10px;
                        font-size: 15px;
                        border-bottom: 1px solid #e6e6e6;
                    }
                    .goods-num .goods-num-editable {
                        display: flex;
                        align-items: center;
                        margin-bottom: 10px;
                        .number {
                            min-width: 20px;
                            display: inline-block;
                            text-align: center;
                            margin: 0 5px;
                            font-size: 14px;
                        }
                        .goods-price{
                            font-size: 16px;
                            padding-left: 25px;
                        }
                        button {
                            border: none;
                            padding: 3px 15px;
                            color: #fff;
                            i {
                                vertical-align: middle;
                            }
                        }
                        .minus {
                            border-bottom-left-radius: 5px;
                            border-top-left-radius: 5px;
                            background: #D3DCE6;
                            &:active {
                                background: darken(#D3DCE6, 10%)
                            }
                        }
                        .plus {
                            border-bottom-right-radius: 5px;
                            border-top-right-radius: 5px;
                            background-color: #0084FF;
                            &:active {
                                background: darken(#0084FF, 10%)
                            }
                        }
                    }
                }
            }
            .cart-boxmobile{
                width:100%;
                text-align: left;
                ul{
                    width: 100%;
                    float: left;
                    padding: 0 20px;
                    font-size: 16px;
                }
                button{
                    margin-top: 10px;
                    font-size: 14px;
                    width: 100px;
                }

            }
            .profile-cart-table {
                width: 100%;
                .check_btn{
                    width: 100%;
                }
                .check_btn1{
                    width: 100%;
                    font-size: 20px;
                    background: transparent;
                    border: 1px solid #0084ff;
                    color: #0084ff;
                }
            }
        }
    }

</style>



// WEBPACK FOOTER //
// ShoppingCart.vue?a28416a8